import React, { useEffect, useMemo } from 'react'
import { connect } from 'react-redux'

import { ReactModal } from '../../../../../components'
import {
  ERROR_ORDER,
  ORDER_MANAGER,
  ORDER_MODAL,
  ORDER_MODAL_ACTION_TEXT,
  ORDER_TYPE,
} from '../../../../../helpers'
import { IMG } from '../../../../../themes'
import { MODAL, ORDER } from '../../../../../reduxs'
import { OrderModalTab } from './components'

import { OrderModalStyle } from './styles'

function OrderCounterModal(props) {
  const {
    selectedTab, 
    language,
    colorTheme,
    submitOrderText,
    editOrderText,
    currentDrinkHashMap,
    currentFoodHashMap,
    currentEquipmentHashMap,
    orderIncrement,
    orderDecrement,
    updateEditOrder,
    selectedOrderTab,
    setSelectedOrderTab,
    confirmOrder,
    setSelectedTab,
    isOpenOrderCounterModal,
    closeOrderCounterModal,
    openConfirmOrderModal,
    openSuccessOrderModal,
    isEditOrder,
    setIsEditOrder,
    resetOrderToInitialValue,
    orderId,
    setErrorModal,
    openCancelOrderModal
  } = props

  const orderModalTab = useMemo(() => {
    return {
      [ORDER_MANAGER.VALUE.CATERING]: [
        { text : ORDER_TYPE.DRINK.TEXT,
          value: ORDER_MODAL.VALUE.DRINK,
        },
        { text : ORDER_TYPE.FOOD.TEXT,
          value: ORDER_MODAL.VALUE.FOOD,
        },
      ],
      [ORDER_MANAGER.VALUE.EQUIPMENT]: [
        { text : ORDER_TYPE.EQUIPMENT.TEXT,
          value: ORDER_MODAL.VALUE.EQUIPMENT,
        },
      ]
    }
  }, [])

  const orderSelector = () => {
    if (selectedOrderTab === ORDER_MODAL.VALUE.DRINK) {
      return currentDrinkHashMap
    } else if (selectedOrderTab === ORDER_MODAL.VALUE.FOOD) {
      return currentFoodHashMap
    } else if (selectedOrderTab === ORDER_MODAL.VALUE.EQUIPMENT) {
      return currentEquipmentHashMap
    } else {
      return {}
    }
  }

  useEffect(() => {
    if (selectedTab === ORDER_MANAGER.VALUE.CATERING) {
      setSelectedOrderTab(ORDER_MODAL.VALUE.DRINK)
    } else if (selectedTab === ORDER_MANAGER.VALUE.EQUIPMENT) {
      setSelectedOrderTab(ORDER_MODAL.VALUE.EQUIPMENT)
    }
  }, [selectedTab])

  const handleBackModal = () => {
    setSelectedTab(selectedTab)
    resetOrderToInitialValue()
    closeOrderCounterModal()
    setIsEditOrder(false)
  }

  const handleAddOrder = (selectedOrderTab) => {
    const canOpenConfirmModal = confirmOrder(selectedOrderTab)
    
    if (canOpenConfirmModal) {
      setSelectedTab(selectedTab)
      resetOrderToInitialValue()
      closeOrderCounterModal()
      openConfirmOrderModal()
    }
  }

  const handleSaveChangeOrder = async (selectedOrderTab, orderId) => {
    const res = await updateEditOrder(selectedOrderTab, orderId)
    if (res.modalAskDeleteOrder === "modalAskDeleteOrder") {
      resetOrderToInitialValue()
      closeOrderCounterModal()
      openCancelOrderModal()
      return
    }
    if(res.status) {
      setSelectedTab(selectedTab)
      resetOrderToInitialValue()
      closeOrderCounterModal()
      openSuccessOrderModal()
    } else {
      setErrorModal(true, ERROR_ORDER.EDIT)
    }
  }

  return (
    <ReactModal isVisible={isOpenOrderCounterModal} width={636} borderRadius={8}>
      <OrderModalStyle colorTheme={colorTheme} >
        <h2 className='order-modal__title'>
          {isEditOrder ? editOrderText : submitOrderText}
        </h2>

        <OrderModalTab
          selectedTab={selectedTab}
          orderModalTab={orderModalTab}
          selectedOrderTab={selectedOrderTab}
          setSelectedOrderTab={setSelectedOrderTab}
        />

        <div className='order-modal__divider' />

        <div className='order-modal__list'>
          {
            Object.values(orderSelector())
              .map((item, index) => {
                return (
                  <div
                    className='order-modal__item'
                    key={`${item.itemName}-${index}`}
                  >
                    <p>{item.itemName}</p>
                    <div className='order-modal__counter'>
                      <button onClick={() => orderDecrement(item.itemId, item.type)}>
                        <img src={IMG['minus.svg']} alt='minus' />
                      </button>
                      <span>{item.amount}</span>
                      <button onClick={() => orderIncrement(item.itemId, item.type)}>
                        <img src={IMG['plus.svg']} alt='plus' />
                      </button>
                    </div>
                  </div>
                )
              })
          }
        </div>

        <div className='order-modal__bottom'>
          <button 
            className='order-modal__bottom__button--back'
            onClick={() => handleBackModal()}
          >
            {ORDER_MODAL_ACTION_TEXT.BACK[language]}
          </button>
          <button
            className='order-modal__bottom__button--add'
            onClick={isEditOrder
               ? () => handleSaveChangeOrder(selectedOrderTab, orderId)
               : () => handleAddOrder(selectedOrderTab)
            }
          >
            {isEditOrder ?  ORDER_MODAL_ACTION_TEXT.SAVE_CHANGE[language] : ORDER_MODAL_ACTION_TEXT.ADD[language]}
          </button>
        </div>

      </OrderModalStyle>
    </ReactModal>
  )
}

const mapStateToProps = ({ orderReducer, accountReducer, modalReducer }) => {
  return {
    colorTheme: accountReducer.user.colorThemePalette,
    currentDrinkHashMap: orderReducer.currentDrinkHashMap,
    currentFoodHashMap: orderReducer.currentFoodHashMap,
    currentEquipmentHashMap: orderReducer.currentEquipmentHashMap,
    isOpenOrderCounterModal: modalReducer.orderModal.isOpenOrderCounterModal,
    isEditOrder: orderReducer.isEditOrder,
    orderId: orderReducer.orderId,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    orderIncrement: (itemId, itemType) => dispatch(ORDER.action.orderIncrement(itemId, itemType)),
    orderDecrement: (itemId, itemType) => dispatch(ORDER.action.orderDecrement(itemId, itemType)),
    resetOrderToInitialValue: () => dispatch(ORDER.action.resetOrderToInitialValue()),
    updateEditOrder: (selectedOrderTab, orderId) => dispatch(ORDER.action.updateEditOrder(selectedOrderTab, orderId)),
    confirmOrder: (selectedOrderTab) => dispatch(ORDER.action.confirmOrder(selectedOrderTab)),
    setErrorModal: (isOpen, text) => dispatch(MODAL.action.setErrorModal(isOpen, text)),
    closeOrderCounterModal: () => dispatch(MODAL.action.setOrderCounterModal(false)),
    openConfirmOrderModal: () => dispatch(MODAL.action.setConfirmOrderModal(true)),
    openSuccessOrderModal: () => dispatch(MODAL.action.setSuccessOrderModal(true)),
    setIsEditOrder: (isEditOrder) => dispatch(ORDER.action.setIsEditOrder(isEditOrder)),
    openCancelOrderModal: () => dispatch(MODAL.action.setCancelOrderModal(true)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(OrderCounterModal)
